"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @constructor
 */
var Ayvri;
(function (Ayvri) {
    var ABF;
    (function (ABF) {
        var TrackDigest = /** @class */ (function () {
            function TrackDigest() {
                /**
                 * @type {flatbuffers.ByteBuffer}
                 */
                this.bb = null;
                /**
                 * @type {number}
                 */
                this.bb_pos = 0;
            }
            /**
             * @param {number} i
             * @param {flatbuffers.ByteBuffer} bb
             * @returns {TrackDigest}
             */
            TrackDigest.prototype.__init = function (i, bb) {
                this.bb_pos = i;
                this.bb = bb;
                return this;
            };
            ;
            /**
             * @param {flatbuffers.ByteBuffer} bb
             * @param {TrackDigest=} obj
             * @returns {TrackDigest}
             */
            TrackDigest.getRootAsTrackDigest = function (bb, obj) {
                return (obj || new TrackDigest).__init(bb.readInt32(bb.position()) + bb.position(), bb);
            };
            ;
            /**
             * @returns {number}
             */
            TrackDigest.prototype.trackId = function () {
                var offset = this.bb.__offset(this.bb_pos, 4);
                return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackDigest.prototype.frameLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 6);
                return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackDigest.prototype.trackLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 8);
                return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            TrackDigest.prototype.timestamp = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 10);
                return offset ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + offset) + index * 8) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackDigest.prototype.timestampLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 10);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Float64Array}
             */
            TrackDigest.prototype.timestampArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 10);
                return offset ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            TrackDigest.prototype.pointCount = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 12);
                return offset ? this.bb.readUint16(this.bb.__vector(this.bb_pos + offset) + index * 2) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackDigest.prototype.pointCountLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 12);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Uint16Array}
             */
            TrackDigest.prototype.pointCountArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 12);
                return offset ? new Uint16Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @param {number} index
             * @returns {number}
             */
            TrackDigest.prototype.pointOffset = function (index) {
                var offset = this.bb.__offset(this.bb_pos, 14);
                return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
            };
            ;
            /**
             * @returns {number}
             */
            TrackDigest.prototype.pointOffsetLength = function () {
                var offset = this.bb.__offset(this.bb_pos, 14);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @returns {Uint32Array}
             */
            TrackDigest.prototype.pointOffsetArray = function () {
                var offset = this.bb.__offset(this.bb_pos, 14);
                return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
            };
            ;
            /**
             * @returns {number}
             */
            TrackDigest.prototype.bytesPerPoint = function () {
                var offset = this.bb.__offset(this.bb_pos, 16);
                return offset ? this.bb.readInt16(this.bb_pos + offset) : 0;
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             */
            TrackDigest.startTrackDigest = function (builder) {
                builder.startObject(7);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} trackId
             */
            TrackDigest.addTrackId = function (builder, trackId) {
                builder.addFieldInt32(0, trackId, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} frameLength
             */
            TrackDigest.addFrameLength = function (builder, frameLength) {
                builder.addFieldInt32(1, frameLength, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} trackLength
             */
            TrackDigest.addTrackLength = function (builder, trackLength) {
                builder.addFieldInt32(2, trackLength, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} timestampOffset
             */
            TrackDigest.addTimestamp = function (builder, timestampOffset) {
                builder.addFieldOffset(3, timestampOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            TrackDigest.createTimestampVector = function (builder, data) {
                builder.startVector(8, data.length, 8);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addFloat64(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackDigest.startTimestampVector = function (builder, numElems) {
                builder.startVector(8, numElems, 8);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} pointCountOffset
             */
            TrackDigest.addPointCount = function (builder, pointCountOffset) {
                builder.addFieldOffset(4, pointCountOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            TrackDigest.createPointCountVector = function (builder, data) {
                builder.startVector(2, data.length, 2);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addInt16(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackDigest.startPointCountVector = function (builder, numElems) {
                builder.startVector(2, numElems, 2);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} pointOffsetOffset
             */
            TrackDigest.addPointOffset = function (builder, pointOffsetOffset) {
                builder.addFieldOffset(5, pointOffsetOffset, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {Array.<number>} data
             * @returns {flatbuffers.Offset}
             */
            TrackDigest.createPointOffsetVector = function (builder, data) {
                builder.startVector(4, data.length, 4);
                for (var i = data.length - 1; i >= 0; i--) {
                    builder.addInt32(data[i]);
                }
                return builder.endVector();
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} numElems
             */
            TrackDigest.startPointOffsetVector = function (builder, numElems) {
                builder.startVector(4, numElems, 4);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {number} bytesPerPoint
             */
            TrackDigest.addBytesPerPoint = function (builder, bytesPerPoint) {
                builder.addFieldInt16(6, bytesPerPoint, 0);
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @returns {flatbuffers.Offset}
             */
            TrackDigest.endTrackDigest = function (builder) {
                var offset = builder.endObject();
                return offset;
            };
            ;
            /**
             * @param {flatbuffers.Builder} builder
             * @param {flatbuffers.Offset} offset
             */
            TrackDigest.finishTrackDigestBuffer = function (builder, offset) {
                builder.finish(offset);
            };
            ;
            return TrackDigest;
        }());
        ABF.TrackDigest = TrackDigest;
    })(ABF = Ayvri.ABF || (Ayvri.ABF = {}));
})(Ayvri = exports.Ayvri || (exports.Ayvri = {}));
